import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

import AppModal from '@/core/components/AppModal.vue';
import AppButton from '@/core/components/form/AppButton.vue';

interface DeleteModalProps {
	title: string,
	resourceName: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDeleteModal',
  props: {
    title: {},
    resourceName: {}
  },
  emits: [
	'cancel',
	'delete',
],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const cancel = () => {
	emit('cancel');
};

const requestDelete = () => {
	emit('delete');
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(AppModal, { onClose: cancel }, {
    header: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(__props.title), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(requestDelete, ["prevent"])
      }, [
        _withDirectives((_openBlock(), _createElementBlock("p", null, [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Är du säker på att du vill ta bort %{ name }? ", -1)
        ]))])), [
          [_directive_translate, {name: __props.resourceName}]
        ]),
        _createElementVNode("p", null, [
          _createVNode(AppButton, { type: "submit" }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Bekräfta", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(AppButton, {
            onClick: cancel,
            class: "t-neutral"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Avbryt", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})